import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import * as React from 'react';
import React__default, { createContext, useContext, forwardRef, useState, useEffect, Fragment } from 'react';
import classNames from 'classnames';
import { useThemeUI, createElement, Themed } from 'theme-ui';
import { jsx, jsxs, Fragment as Fragment$1 } from 'theme-ui/jsx-runtime';
import { Type } from '@uswitch/spark';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { leftPad, toSnakeCase } from '@uswitch/ev-utils/string';
import { useMeta, useComponent, useDataSelector, useDoHydrateComponent, usePalette as usePalette$1, useComponentMeta, useEntity, useIncludes, useOptions, useDebugHydration, getEntity, useExperiences } from '@uswitch/ev-utils/context/selectors';
import sw$1 from '@uswitch/ev-utils/switch';
import { dataProps, assignContentTypeId, fileType, contentTypeId, contentId, layoutId, variantId } from '@uswitch/ev-utils/contentful';
import { isEmpty, isObject } from '@uswitch/ev-utils/obj';
import ConditionalHydrate, { RedWrapper } from '@uswitch/ev-utils/conditional-hydrate';
import { useTrackModule, ComponentTrackingContext } from '@uswitch/ev-utils/component-events';
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import merge from 'deepmerge';
import { M as MODULE_VARIANT_SEPARATOR, a as MODULE_ID_SEPARATOR, t as toSiblingMap, b as __example__devModuleIds, F as FIRST_MODULE_ID } from '../../dist/sibling-spacing-b40c0e36.esm.js';
import { Experiment, Fallback } from '@uswitch/ev-utils/experiments';
export { default as EVCoreProvider } from '@uswitch/ev-utils/context/provider';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { Global as Global$1, css } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';

var _excluded$7 = ["children", "cols", "span", "className"],
  _excluded2$4 = ["children", "cols", "direction", "wrap"],
  _excluded3$1 = ["children", "cols", "span", "offset"],
  _excluded4 = ["layout"],
  _excluded5 = ["key"];
var getGutterSize = function getGutterSize(theme) {
  var _theme$layout$flexGr;
  return (theme === null || theme === void 0 ? void 0 : theme.layout) && (theme === null || theme === void 0 ? void 0 : (_theme$layout$flexGr = theme.layout['flex-grid'].sizes) === null || _theme$layout$flexGr === void 0 ? void 0 : _theme$layout$flexGr.gutter);
};
var getVerticalGutterSize = function getVerticalGutterSize(theme) {
  var _theme$layout$flexGr2;
  return (theme === null || theme === void 0 ? void 0 : theme.layout) && (theme === null || theme === void 0 ? void 0 : (_theme$layout$flexGr2 = theme.layout['flex-grid'].sizes) === null || _theme$layout$flexGr2 === void 0 ? void 0 : _theme$layout$flexGr2.verticalGutter);
};
var getContainerSize = function getContainerSize(theme) {
  var _theme$layout$flexGr3, _theme$layout$flexGr4;
  return (theme === null || theme === void 0 ? void 0 : theme.layout) && (theme === null || theme === void 0 ? void 0 : (_theme$layout$flexGr3 = theme.layout['flex-grid']) === null || _theme$layout$flexGr3 === void 0 ? void 0 : (_theme$layout$flexGr4 = _theme$layout$flexGr3.container) === null || _theme$layout$flexGr4 === void 0 ? void 0 : _theme$layout$flexGr4.maxWidth) || 1200;
};
var useContainerSize = function useContainerSize() {
  var _useThemeUI = useThemeUI(),
    theme = _useThemeUI.theme;
  return getContainerSize(theme);
};
var castArray = function castArray(valueOrArray) {
  return [].concat(valueOrArray);
}; // wiiilllllson

var getValueFromSize = function getValueFromSize(theme, size) {
  return typeof size === 'number' ? size : theme.space[size] || 0;
};
var getHalf = function getHalf(value) {
  return value / 2;
};

// if we originally had a value outside of an array return it that way
// otherwise the undefined values will cause incorrect responsivness
var uncastArrayIfSingle = function uncastArrayIfSingle(arr) {
  return arr.length === 1 ? arr[0] : arr;
};
var toPx = function toPx(value) {
  return "".concat(value, "px");
};
var getValueFromBreakpointIndex = function getValueFromBreakpointIndex(arr, index) {
  if (arr[index] !== undefined) return arr[index];
  return arr[arr.length - 1];
};
var isChildOfContainerContext = /*#__PURE__*/React.createContext();
var columnSizeContext = /*#__PURE__*/React.createContext();
var Container$2 = function Container(_ref) {
  var children = _ref.children,
    cols = _ref.cols,
    span = _ref.span,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var classes = classNames('flex-grid-container', className);
  var colsArray = castArray(cols);
  var spanArray = castArray(span);
  return jsx("div", _objectSpread(_objectSpread({
    sx: {
      mx: 'auto',
      boxSizing: 'border-box',
      px: getGutterSize,
      maxWidth: function maxWidth(theme) {
        return uncastArrayIfSingle(castArray(getContainerSize(theme)).map(function (maxWidth, i) {
          return maxWidth * (colsArray[i] && spanArray[i] ? spanArray[i] / colsArray[i] : 1);
        }));
      },
      variant: 'compounds.container.flex'
    }
  }, props), {}, {
    className: classes,
    children: jsx(isChildOfContainerContext.Provider, {
      value: true,
      children: children
    })
  }));
};
var Row$1 = function Row(_ref2) {
  var children = _ref2.children,
    _ref2$cols = _ref2.cols,
    cols = _ref2$cols === void 0 ? 12 : _ref2$cols,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? ['column', 'row', 'row'] : _ref2$direction,
    _ref2$wrap = _ref2.wrap,
    wrap = _ref2$wrap === void 0 ? true : _ref2$wrap,
    props = _objectWithoutProperties(_ref2, _excluded2$4);
  var childrenArray = Array.isArray(children) ? children : [children];
  return jsx("div", _objectSpread(_objectSpread({
    sx: {
      mx: function mx(theme) {
        return uncastArrayIfSingle(castArray(getGutterSize(theme)).map(function (value) {
          return getValueFromSize(theme, value);
        }).map(getHalf).map(function (gutterValue) {
          return "".concat(gutterValue * -1);
        }).map(toPx));
      },
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'nowrap'
    }
  }, props), {}, {
    children: childrenArray.map(function (child, key) {
      return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
        cols: cols,
        key: key
      }) : child;
    })
  }));
};
var Col = function Col(_ref3) {
  var children = _ref3.children,
    _ref3$cols = _ref3.cols,
    cols = _ref3$cols === void 0 ? 12 : _ref3$cols,
    span = _ref3.span,
    offset = _ref3.offset,
    props = _objectWithoutProperties(_ref3, _excluded3$1);
  var _useThemeUI2 = useThemeUI(),
    theme = _useThemeUI2.theme;
  if (Array.isArray(span) && !Array.isArray(cols)) {
    var colsNumber = cols;
    cols = [];
    for (var i = 0; i < span.length; i++) {
      cols.push(colsNumber);
    }
  }
  var columnValues = castArray(cols).map(function (colValue, index) {
    var gutterValue = toPx(getValueFromBreakpointIndex(castArray(getGutterSize(theme)).map(function (value) {
      return getValueFromSize(theme, value);
    }), index));
    var currentSpan = getValueFromBreakpointIndex(castArray(span), index);
    return {
      currentSpan: currentSpan,
      colValue: colValue,
      gutterValue: gutterValue
    };
  });
  var width = uncastArrayIfSingle(columnValues.map(function (_ref4) {
    var currentSpan = _ref4.currentSpan,
      colValue = _ref4.colValue,
      gutterValue = _ref4.gutterValue;
    return "calc(".concat(currentSpan / colValue * 100, "% - ").concat(gutterValue, ")");
  }));
  return jsx(columnSizeContext.Provider, {
    value: columnValues,
    children: jsx("div", _objectSpread(_objectSpread({
      sx: _objectSpread(_objectSpread({
        boxSizing: 'border-box',
        mr: function mr(theme) {
          return uncastArrayIfSingle(castArray(getGutterSize(theme)).map(function (value) {
            return getValueFromSize(theme, value);
          }).map(getHalf).map(toPx));
        },
        mb: getVerticalGutterSize,
        flexGrow: span ? 0 : 1,
        flexShrink: 0,
        flexBasis: "auto"
      }, span ? {
        width: width
      } : {}), offset ? {
        ml: function ml(theme) {
          return uncastArrayIfSingle(castArray(cols).map(function (colValue, index) {
            var gutterValue = getValueFromBreakpointIndex(castArray(getGutterSize(theme)).map(function (value) {
              return getValueFromSize(theme, value);
            }), index);
            var offsetValue = getValueFromBreakpointIndex(castArray(offset).map(function (value) {
              return getValueFromSize(theme, value);
            }), index);
            return "calc(".concat(offsetValue / colValue * 100, "% + ").concat(gutterValue / 2, "px)");
          }));
        }
      } : {
        ml: function ml(theme) {
          return uncastArrayIfSingle(castArray(getGutterSize(theme)).map(function (value) {
            return getValueFromSize(theme, value);
          }).map(getHalf).map(toPx));
        }
      })
    }, props), {}, {
      children: children
    }))
  });
};
var GridFromJson = function GridFromJson(_ref5) {
  var json = _ref5.json,
    childrenArray = _ref5.childrenArray;
  var flatLayout = json.reduce(function (cells, _ref6) {
    var layout = _ref6.layout;
    return cells.concat(layout);
  }, []);
  var usedKeys = flatLayout.map(function (_ref7) {
    var key = _ref7.key;
    return key;
  });
  var autoKey = 0;
  // In the future, string key could be support for contentful block ID
  var getChildFromKey = function getChildFromKey(key) {
    // If no key, search for the next key that isn't already used
    if (typeof key === 'undefined') {
      while (usedKeys.includes(autoKey)) {
        autoKey++;
      }
      usedKeys.push(autoKey);
      key = autoKey;
    }
    if (key === '*') {
      throw new Error('Use getWildcardChildren() for this');
    }

    // We need to pass an ID back as if the key is generated it'll be undefined
    // in the JSX
    return {
      id: key,
      component: childrenArray[key]
    };
  };
  var getWildcardChildren = function getWildcardChildren() {
    var wildcardCount = childrenArray.length - flatLayout.length + 1;
    var wildCardChildren = [];
    for (var i = 0; i < wildcardCount; i++) {
      wildCardChildren.push(getChildFromKey());
    }
    return wildCardChildren;
  };
  return jsx(React.Fragment, {
    children: json.map(function (_ref8, i) {
      var layout = _ref8.layout,
        rowProps = _objectWithoutProperties(_ref8, _excluded4);
      return createElement(Row$1, _objectSpread(_objectSpread({}, rowProps), {}, {
        key: i
      }), layout.map(function (_ref9) {
        var key = _ref9.key,
          colProps = _objectWithoutProperties(_ref9, _excluded5);
        if (key === '*') {
          return getWildcardChildren().map(function (_ref10) {
            var id = _ref10.id,
              component = _ref10.component;
            return createElement(Col, _objectSpread(_objectSpread({}, colProps), {}, {
              key: id,
              className: "json-grid-col"
            }), component);
          });
        }
        var _getChildFromKey = getChildFromKey(key),
          id = _getChildFromKey.id,
          component = _getChildFromKey.component;
        return createElement(Col, _objectSpread(_objectSpread({}, colProps), {}, {
          key: id,
          className: "json-grid-col"
        }), component);
      }));
    })
  });
};

var _excluded$6 = ["children", "className", "px"];
var sw = function sw(cases) {
  return function (prop) {
    var f = {}.hasOwnProperty.call(cases, prop) ? cases[prop] : cases.default;
    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }
    return f instanceof Function ? f.apply(void 0, data) : f;
  };
};
var PaletteContext = /*#__PURE__*/createContext({});
var PaletteProvider = PaletteContext.Provider;
var createSx = function createSx() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !obj ? {} : Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return sw({
      object: function object() {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, createSx(palette, value)));
      },
      function: function _function() {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value(palette)));
      },
      default: function _default() {
        var mobileBackgroundColor = palette.mobileBackgroundColor,
          backgroundColor = palette.backgroundColor;
        if (mobileBackgroundColor && key === 'backgroundColor') {
          return palette[value] ? _objectSpread(_objectSpread({}, acc), {}, {
            backgroundColor: [mobileBackgroundColor, backgroundColor, backgroundColor]
          }) : acc;
        } else {
          return palette[value] ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, palette[value])) : acc;
        }
      }
    })(_typeof(value));
  }, {});
};
var usePalette = function usePalette() {
  var palette = useContext(PaletteContext);
  return palette;
};

/**
   TODO:
   To prevent margin collapse, which should use emotion utils to read
   the parent styles and only set the vertical padding when a padding
   is 0 or not set

   Similarly, in order to prevent margin collapse for palettes, you
   should add the following snippet as high up in your document as
   possible

   <style>.palette{padding-top:0.05px;padding-bottom:0.05px}</style>
 */

var Palette = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$px = _ref3.px,
    px = _ref3$px === void 0 ? {} : _ref3$px,
    props = _objectWithoutProperties(_ref3, _excluded$6);
  var palette = usePalette();
  var sx = createSx(palette, px);
  return jsx(props.as, _objectSpread(_objectSpread({}, props), {}, {
    sx: {
      '&.palette': sx
    },
    className: "palette ".concat(className),
    ref: ref,
    children: children
  }));
});

var __displayModMarker;
var displayModMarker = function displayModMarker() {
  if (typeof window === 'undefined') return false;
  if (typeof __displayModMarker === 'undefined') {
    try {
      var _window$localStorage;
      __displayModMarker = (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem('evcore/mod-marker');
    } catch (e) {
      // swallow
    }
  }
  return __displayModMarker;
};
var ModMarker = (function (_ref) {
  var entity = _ref.entity;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    init = _useState2[0],
    setInit = _useState2[1];
  useEffect(function () {
    return setInit(typeof window !== 'undefined');
  }, []);
  return init ? jsx("script", _objectSpread({
    type: "application/mod-marker"
  }, dataProps(entity))) : null;
});

var defaultModuleStyles = {
  mx: 'auto'
};
var spacingStyles = {
  spacingTop: 'marginTop',
  spacingBottom: 'marginBottom',
  spacingY: 'marginY'
};
var removeTopSpacingStyles = {
  mt: [0, 0, 0]
};
var removeBottomSpacingStyles = {
  mb: [0, 0, 0]
};
var getWrapperConfigStyles = function getWrapperConfigStyles(_ref) {
  var wrapperConfig = _ref.wrapperConfig,
    variant = _ref.variant;
  return Object.entries(wrapperConfig).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    if (spacingStyles[key]) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, spacingStyles[key], value));
    }
    if (key === 'variants') {
      var variantConfig = value[variant];
      if (variantConfig) {
        Object.entries(variantConfig).forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            key1 = _ref5[0],
            value1 = _ref5[1];
          if (spacingStyles[key1]) {
            acc = _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, spacingStyles[key1], value1));
          }
        });
      }
    }
    return acc;
  }, {});
};
var getSpacingConfigStyles = function getSpacingConfigStyles(_ref6) {
  var spacingConfig = _ref6.spacingConfig;
  return Object.entries(spacingConfig).reduce(function (acc, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      value = _ref8[1];
    if (spacingStyles[key]) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, spacingStyles[key], value));
    }
    return acc;
  }, {});
};
var ModuleContainer = function ModuleContainer(_ref9) {
  var _useMeta;
  var children = _ref9.children,
    _ref9$spacing = _ref9.spacing,
    spacingConfig = _ref9$spacing === void 0 ? {} : _ref9$spacing,
    _ref9$wrapperConfig = _ref9.wrapperConfig,
    wrapperConfig = _ref9$wrapperConfig === void 0 ? {} : _ref9$wrapperConfig,
    _ref9$removeTopSpacin = _ref9.removeTopSpacing,
    removeTopSpacing = _ref9$removeTopSpacin === void 0 ? false : _ref9$removeTopSpacin,
    _ref9$removeBottomSpa = _ref9.removeBottomSpacing,
    removeBottomSpacing = _ref9$removeBottomSpa === void 0 ? false : _ref9$removeBottomSpa,
    variant = _ref9.variant,
    _ref9$moduleSpacing = _ref9.moduleSpacing,
    moduleSpacing = _ref9$moduleSpacing === void 0 ? false : _ref9$moduleSpacing,
    entryUseContainer = _ref9.entryUseContainer;
  var hasContainer = moduleSpacing === true && ((wrapperConfig === null || wrapperConfig === void 0 ? void 0 : wrapperConfig.useContainer) !== false || entryUseContainer ? entryUseContainer !== false : false);
  var wrapperConfigStyles = getWrapperConfigStyles({
    wrapperConfig: wrapperConfig,
    variant: variant
  });
  var spacing = getSpacingConfigStyles({
    spacingConfig: spacingConfig
  });
  var interModuleSpacing = (_useMeta = useMeta(['interModuleSpacing'], undefined)) !== null && _useMeta !== void 0 ? _useMeta : 'xxl';
  var sx = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultModuleStyles), moduleSpacing ? {
    my: interModuleSpacing
  } : {
    my: 'sm'
  }), hasContainer ? {
    variant: 'container.moduleContainer'
  } : {}), wrapperConfigStyles), spacing), removeTopSpacing ? removeTopSpacingStyles : {}), removeBottomSpacing ? removeBottomSpacingStyles : {});
  return jsx("div", {
    sx: sx,
    children: jsx(isChildOfContainerContext.Provider, {
      value: hasContainer,
      children: children
    })
  });
};

var px = {
  background: 'background',
  backgroundColor: 'backgroundColor',
  color: 'textColor',
  'h1, h2, h3, h4, h5, h6, a, strong, b': {
    color: 'accentTextColor'
  }
};
var EVComponent = function EVComponent(props) {
  var _props$sys;
  var _useComponent = useComponent(props),
    _useComponent2 = _slicedToArray(_useComponent, 4),
    err = _useComponent2[0],
    C = _useComponent2[1],
    wrapperConfig = _useComponent2[2],
    features = _useComponent2[3];
  var _useDataSelector = useDataSelector(['dates'], {}),
    publishDate = _useDataSelector.publishDate,
    updatedDate = _useDataSelector.updatedDate;
  var id = props.id || ((_props$sys = props.sys) === null || _props$sys === void 0 ? void 0 : _props$sys.id);
  var doHydrateComponent = useDoHydrateComponent(id);
  var doHydrate = props.forceHydrate || doHydrateComponent;
  var _useTrackModule = useTrackModule(props),
    trackComponent = _useTrackModule.trackComponent,
    trackProps = _useTrackModule.trackProps;
  var paletteFromContext = usePalette();
  var paletteFromProp = usePalette$1(props.palette);
  var _props$sys2 = props.sys;
  _props$sys2 = _props$sys2 === void 0 ? {} : _props$sys2;
  var contentTypeId = _props$sys2.contentTypeId,
    v = props.variant,
    variants = props.variants;
  var variant = v !== null && v !== void 0 ? v : variants;
  var _useComponentMeta = useComponentMeta(contentTypeId, variant, {}),
    defaultVariantPalette = _useComponentMeta.defaultPalette;
  var _useComponentMeta2 = useComponentMeta(contentTypeId, undefined, {}),
    defaultComponentPalette = _useComponentMeta2.defaultPalette;
  var defaultPalette = _objectSpread(_objectSpread({}, defaultComponentPalette), defaultVariantPalette);
  var customPalette = !isEmpty(paletteFromProp) ? paletteFromProp : paletteFromContext;
  var palette = _objectSpread(_objectSpread({}, defaultPalette), customPalette);
  var sx = _objectSpread({}, createSx(palette, px));
  var deactivateMarginCollapse = useMeta(['deactivateMarginCollapse'], false);
  if (deactivateMarginCollapse || !isEmpty(palette)) {
    sx.py = '0.05px';
  }

  // TODO: Handle errors in finding the component
  if (err) {
    console.log({
      err: err
    });
    return null;
  }
  var additionalProps = {};
  if (features !== null && features !== void 0 && features.localDates) {
    var _props$sys3, _props$sys4;
    additionalProps.localDates = {
      dateCreated: props === null || props === void 0 ? void 0 : (_props$sys3 = props.sys) === null || _props$sys3 === void 0 ? void 0 : _props$sys3.createdAt,
      dateUpdated: props === null || props === void 0 ? void 0 : (_props$sys4 = props.sys) === null || _props$sys4 === void 0 ? void 0 : _props$sys4.updatedAt
    };
  }
  if (features !== null && features !== void 0 && features.globalDates) {
    additionalProps.globalDates = {
      dateCreated: publishDate,
      dateUpdated: updatedDate
    };
  }
  return jsxs(Fragment, {
    children: [displayModMarker() && jsx(ModMarker, {
      entity: props
    }), jsx(ConditionalHydrate, {
      force: doHydrate,
      As: "div",
      sx: _objectSpread({
        position: 'relative'
      }, sx),
      "data-component-tracking": JSON.stringify(trackProps),
      children: jsx(ModuleContainer, {
        wrapperConfig: wrapperConfig,
        spacing: props.spacing,
        removeTopSpacing: props.removeTopSpacing,
        removeBottomSpacing: props.removeBottomSpacing,
        variant: variant,
        moduleSpacing: props.moduleSpacing,
        entryUseContainer: props.useContainer,
        children: jsx(ComponentTrackingContext.Provider, {
          value: trackComponent,
          children: jsx(C, _objectSpread(_objectSpread({}, props), additionalProps))
        })
      })
    })]
  });
};

var EVEntry = function EVEntry(props) {
  var rawEntity = useEntity(props);
  if (rawEntity.err) {
    console.log({
      err: rawEntity.err,
      props: props
    });
  }
  var entity = sw$1({
    'image/svg+xml': assignContentTypeId('imageModule'),
    'image/jpeg': assignContentTypeId('imageModule'),
    default: function _default(i) {
      return i;
    }
  })(fileType(rawEntity), rawEntity);
  return jsx(EVComponent, _objectSpread(_objectSpread({}, props), entity));
};

var init = function init() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return arr.slice(0, -1);
};
var last = function last() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return arr.slice(-1)[0];
};

/**
 * sequentialGroupBy groups a list of items based on the result of groupP
 *
 * A good example of this is for palettes, where the grouped things
 * will be a tuple of [ palette, [ ...group ] ]
 *
 * @param {any[]} items A list of items to be sequentially grouped
 * @param {Function} groupP a predicate function that returns `true' if you should create a new group
 * @param {Function} groupF a function to build the group object
 * @returns {any[[][]]} A list of tuples of [GroupCreator]
 */
var sequentialGroupBy = function sequentialGroupBy() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var groupP = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
    return i;
  };
  var groupF = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (i) {
    return i;
  };
  return arr.reduce(function (acc, entry, i, initArr) {
    if (groupP(entry, i, initArr)) return [].concat(_toConsumableArray(acc), [[groupF(entry), []]]);
    var front = init(acc);
    var _last = last(acc),
      _last2 = _slicedToArray(_last, 2),
      group = _last2[0],
      items = _last2[1];
    return [].concat(_toConsumableArray(front), [[group, items.concat(entry)]]);
  }, [[null, []]]);
};
var unnest = function unnest() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var unnestP = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a) {
    return false;
  };
  return arr.reduce(function (acc, cur, i, initArr) {
    var front = init(acc);
    var prev = last(acc) || [];
    if (unnestP(cur)) return [].concat(_toConsumableArray(front), [prev, cur]);
    if (unnestP(prev)) return [].concat(_toConsumableArray(front), [prev, [cur]]);
    return [].concat(_toConsumableArray(front), [[].concat(prev).concat(cur)]);
  }, [[]]).filter(function (item) {
    return !Array.isArray(item) || item.length > 0;
  });
};

/**
 * @typedef {Function} ApplyPredicate
 * @param {Object} prevItem - The previous item in the list to test
 * @param {Object} currItem - The current item in the list to test
 * @returns {any} Returns a truthy value that can be passed into the `ApplyFunction`
 */

/**
 * @typedef {Function} ApplyFunction
 * @param {integer} i The index of the item being modified, i.e. 0 for first, 1 for second
 * @param {Object} item The item to be modified
 * @param {Object} [context] - Extra information to be passed
 * @returns {Object} Returns the modified `item`
 */

/**
 * applyToPairWhen applies a function to pairs within a list based on
 * a predicate
 *
 * A good example of this is for sibling spacing, where we look for
 * pairs of entries in a list of modules and modify them to include
 * some configured spacing
 *
 * @param {any[]} items A list of items to scan over and modify
 * @param {ApplyPredicate} applyP a predicate function that takes the current & previous entries in the list, returns `true' if you should apply `applyF` to them
 * @param {ApplyFunction} applyF a function to modify the entries, it is called with the index of the pair to modify, e.g. 0, 1
 * @returns {[any[],Boolean]} A tuple of the newly modified list of the original `items`, and a boolean of whether it was modified
 **/
var applyToPairWhen = function applyToPairWhen() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var applyP = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a) {
    return false;
  };
  var applyF = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_) {
    return _;
  };
  var modded = false;
  return [items.reduce(function (acc, currentModule, i) {
    var frontModules = init(acc);
    var previousModule = last(acc) || {};
    var applyMatch = applyP(previousModule, currentModule, i);
    if (applyMatch) {
      modded = true;

      /*
       * We have a match on the first module, when previous module
       * is undefined so we should only call applyF on the 1th,
       * i.e., currentModule which is the first module in `items`
       */
      if (i === 0) return frontModules.concat([applyF(1, currentModule, applyMatch)]);
      return frontModules.concat([applyF(0, previousModule, applyMatch), applyF(1, currentModule, applyMatch)]);
    }
    return acc.concat(currentModule);
  }, []), modded];
};

var _excluded$5 = ["parentContentType", "wrapper", "children", "variant", "styling", "spacing", "textContent"];
var parentIds = ['modularPage', 'richPage'];
var ContainerDivStyle = function ContainerDivStyle(_ref) {
  var children = _ref.children,
    styling = _ref.styling,
    variant = _ref.variant;
  var _useComponent = useComponent({
      tag: 'container'
    }),
    _useComponent2 = _slicedToArray(_useComponent, 2),
    C = _useComponent2[1];
  return jsx(C, {
    className: '',
    children: jsx("div", {
      sx: _objectSpread({
        variant: variant
      }, styling),
      children: children
    })
  });
};
var DivStyle = function DivStyle(_ref2) {
  var children = _ref2.children,
    styling = _ref2.styling,
    variant = _ref2.variant;
  return jsx("div", {
    sx: _objectSpread({
      variant: variant
    }, styling),
    children: children
  });
};
var TextContentDiv = function TextContentDiv(_ref3) {
  var _theme$layout, _theme$layout$contain, _theme$layout$contain2;
  var children = _ref3.children;
  var _useComponent3 = useComponent({
      tag: 'container'
    }),
    _useComponent4 = _slicedToArray(_useComponent3, 2),
    C = _useComponent4[1];
  var _useThemeUI = useThemeUI(),
    theme = _useThemeUI.theme;
  return jsx(C, {
    children: theme !== null && theme !== void 0 && (_theme$layout = theme.layout) !== null && _theme$layout !== void 0 && (_theme$layout$contain = _theme$layout.container) !== null && _theme$layout$contain !== void 0 && (_theme$layout$contain2 = _theme$layout$contain.content) !== null && _theme$layout$contain2 !== void 0 && _theme$layout$contain2.contentStyle ? jsx("div", {
      sx: {
        variant: 'layout.container.content.contentStyle'
      },
      children: children
    }) : children
  });
};
var Container$1 = function Container(_ref4) {
  var children = _ref4.children;
  var _useComponent5 = useComponent({
      tag: 'container'
    }),
    _useComponent6 = _slicedToArray(_useComponent5, 2),
    C = _useComponent6[1];
  return jsx(C, {
    className: '',
    sx: {},
    children: children
  });
};
var SmartContainer = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var parentContentType = _ref5.parentContentType,
    wrapper = _ref5.wrapper,
    children = _ref5.children,
    variant = _ref5.variant,
    _ref5$styling = _ref5.styling,
    styling = _ref5$styling === void 0 ? {} : _ref5$styling,
    _ref5$spacing = _ref5.spacing,
    spacing = _ref5$spacing === void 0 ? {} : _ref5$spacing,
    _ref5$textContent = _ref5.textContent,
    textContent = _ref5$textContent === void 0 ? false : _ref5$textContent,
    props = _objectWithoutProperties(_ref5, _excluded$5);
  var _useComponent7 = useComponent({
      tag: 'palette'
    }),
    _useComponent8 = _slicedToArray(_useComponent7, 2),
    Palette = _useComponent8[1];
  var parentIsRootEntity = parentIds.includes(parentContentType);
  // do not use container if useContainer is false
  var useContainer = ((wrapper === null || wrapper === void 0 ? void 0 : wrapper.useContainer) !== false || (props === null || props === void 0 ? void 0 : props.useContainer)) && parentIsRootEntity;
  var useStyles = variant || Object.keys(styling).length > 0;
  return jsx(Palette, _objectSpread(_objectSpread({
    as: "div",
    sx: parentIsRootEntity ? _objectSpread({}, spacing) : {},
    px: {
      backgroundColor: parentIsRootEntity ? 'backgroundColor' : '',
      color: 'textColor'
    }
  }, props), {}, {
    ref: ref,
    children: textContent && parentIsRootEntity ? jsx(TextContentDiv, {
      children: children
    }) : useContainer && useStyles ? jsx(ContainerDivStyle, {
      variant: variant,
      styling: styling,
      children: children
    }) : useStyles ? jsx(DivStyle, {
      variant: variant,
      styling: styling,
      children: children
    }) : useContainer ? jsx(Container$1, {
      children: children
    }) : children
  }));
});

var _excluded$4 = ["content", "style", "optionOverrides"];
var ReactElementOrModule$1 = function ReactElementOrModule(_ref) {
  var item = _ref.item,
    index = _ref.index,
    _ref$moduleIndexPrefi = _ref.moduleIndexPrefix,
    moduleIndexPrefix = _ref$moduleIndexPrefi === void 0 ? '' : _ref$moduleIndexPrefi,
    childOfPage = _ref.childOfPage;
  return /*#__PURE__*/React__default.isValidElement(item) ? jsx(item.type, _objectSpread({}, item.props)) : jsx(EVEntry, _objectSpread(_objectSpread({}, item), {}, {
    moduleIndex: "".concat(moduleIndexPrefix, "-").concat(leftPad(index)),
    track: childOfPage
  }));
};
var PaletteWrapper$2 = function PaletteWrapper(_ref2) {
  var palette = _ref2.palette,
    children = _ref2.children;
  return jsx(PaletteProvider, {
    value: usePalette$1(palette),
    children: children
  });
};
var RichText$1 = function RichText(_ref3) {
  var _entity$sys;
  var document = _ref3.content,
    _ref3$style = _ref3.style,
    style = _ref3$style === void 0 ? {} : _ref3$style,
    optionOverrides = _ref3.optionOverrides,
    entity = _objectWithoutProperties(_ref3, _excluded$4);
  var includes = useIncludes();
  var options = useOptions();
  var config = {
    optionOverrides: optionOverrides
  };
  var optionsWithOverrides = options(config);
  var debugHydration = useDebugHydration();
  var doHydrateComponent = useDoHydrateComponent((_entity$sys = entity.sys) === null || _entity$sys === void 0 ? void 0 : _entity$sys.id);
  var doHydrate = entity.forceHydrate || !entity.sys || doHydrateComponent;
  if (!document) return jsx(Fragment$1, {});
  // For storybook
  if (typeof document === 'string') return jsx("div", {
    children: document
  });
  var untrimmedContentArr = Array.isArray(document) ? document : Array.isArray(document.content) ? document.content : [];
  var contentArr = untrimmedContentArr.reduce(function (acc, entry) {
    var nodeType = entry.nodeType,
      _entry$content = entry.content,
      content = _entry$content === void 0 ? [] : _entry$content;

    // When trimming rich content, we should only trim items that are
    // not assets or entries
    if (nodeType === 'embedded-entry-block' || nodeType === 'embedded-asset-block') {
      return acc.concat(entry);
    }
    var trimmedContent = content.filter(function (_ref4) {
      var value = _ref4.value;
      return !/^$/.test(value);
    });
    return trimmedContent.length ? acc.concat(_objectSpread(_objectSpread({}, entry), {}, {
      content: trimmedContent
    })) : acc;
  }, []).map(function (mod, i) {
    return _objectSpread(_objectSpread({}, mod), {}, {
      index: i
    });
  });
  var moduleListLength = contentArr.length;
  var paletteGroups = sequentialGroupBy(contentArr, function (mod) {
    return contentTypeId(getEntity(mod.data.target, includes)) === 'palette';
  }, function (mod) {
    return mod.data.target;
  });
  var groupedBlocks = paletteGroups.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      palette = _ref6[0],
      content = _ref6[1];
    return [palette, unnest(content, function (_ref7) {
      var nodeType = _ref7.nodeType;
      return nodeType === 'embedded-entry-block';
    })];
  });
  return jsxs(ConditionalWrapper, {
    condition: !doHydrate,
    wrapper: ConditionalHydrate,
    otherwise: debugHydration ? RedWrapper : undefined,
    children: [displayModMarker() && jsx(ModMarker, {
      entity: entity
    }), groupedBlocks.map(function (_ref8, i) {
      var _ref9 = _slicedToArray(_ref8, 2),
        palette = _ref9[0],
        groups = _ref9[1];
      return groups.map(function (group, j) {
        var content = documentToReactComponents({
          content: [].concat(group)
        }, optionsWithOverrides);
        var isEmbeddedEntry = group.nodeType === 'embedded-entry-block';
        var first = i === 0 && j === 0;
        var key = "rich-pallete_".concat(leftPad(i), "-group_").concat(leftPad(j));
        if (isEmbeddedEntry) {
          return jsx(ConditionalWrapper, {
            condition: !!palette,
            wrapper: PaletteWrapper$2,
            palette: palette,
            children: jsx(EVEntry, _objectSpread(_objectSpread({}, content[0]), {}, {
              moduleIndex: key,
              track: false,
              removeTopSpacing: first,
              removeBottomSpacing: group.index + 1 === moduleListLength
            }))
          }, key);
        }
        return jsxs(ConditionalWrapper, {
          condition: !!palette,
          wrapper: PaletteWrapper$2,
          palette: palette,
          children: [displayModMarker() && jsx(ModMarker, {
            entity: entity
          }), jsx(SmartContainer, {
            styling: entity.styling,
            textContent: true,
            sx: _objectSpread({}, style),
            children: content.map(function (item, index) {
              return jsx(ReactElementOrModule$1, {
                index: index,
                item: item,
                moduleIndexPrefix: "key",
                childOfPage: false
              }, index);
            }, this)
          })]
        }, key);
      });
    })]
  });
};

var _excluded$3 = ["children", "className", "href"],
  _excluded2$3 = ["children", "variant", "href", "className"];
var sameHostParams = function sameHostParams(host) {
  var href = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  try {
    var sameHost = host === new URL(href).host;
    return sameHost ? {} : {
      target: '_blank',
      rel: 'noopener noreferrer'
    };
  } catch (e) {
    return {};
  }
};
var Link = function Link(_ref) {
  var children = _ref.children,
    className = _ref.className,
    href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var host = useDataSelector(['location', 'host']);
  var hostParams = sameHostParams(host, href);
  var vertical = useMeta(['appName'], 'eevee');
  return jsx(Themed.a, _objectSpread(_objectSpread(_objectSpread({
    href: href,
    className: className,
    "data-nerd": true,
    "data-nerd-type": "element",
    "data-nerd-clickable": true,
    "data-nerd-clickable-target": true,
    "data-nerd-props": JSON.stringify({
      org_vertical: vertical,
      element_name: props === null || props === void 0 ? void 0 : props.name,
      contentful_id: contentId(props)
    })
  }, props), hostParams), {}, {
    children: children
  }));
};
var LinkWithChevron = function LinkWithChevron(_ref2) {
  var children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? '' : _ref2$variant,
    _ref2$href = _ref2.href,
    href = _ref2$href === void 0 ? '' : _ref2$href,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2$3);
  var host = useDataSelector(['location', 'host']);
  var sameHost = sameHostParams(host, href);
  var vertical = useMeta(['appName'], 'eevee');
  return jsx(Themed.a, _objectSpread(_objectSpread(_objectSpread({
    className: variant ? "".concat(variant, " ").concat(className) : className,
    href: href,
    "data-nerd": true,
    "data-nerd-type": "element",
    "data-nerd-clickable": true,
    "data-nerd-clickable-target": true,
    "data-nerd-props": JSON.stringify({
      org_vertical: vertical,
      element_name: props === null || props === void 0 ? void 0 : props.name,
      contentful_id: contentId(props)
    })
  }, props), sameHost), {}, {
    sx: _objectSpread({}, variant ? {
      variant: "styles.a.".concat(variant)
    } : {}),
    children: jsx("span", {
      sx: {
        variant: 'elements.link-with-chevron'
      },
      children: children
    })
  }));
};

var stylePath = function stylePath(field) {
  return getVariantPath({
    atomicType: 'compounds',
    componentId: 'author-snippet',
    field: field
  });
};
var AuthorSnippet = function AuthorSnippet(_ref) {
  var snippet = _ref.snippet,
    author = _ref.name,
    url = _ref.url;
  var _useMeta = useMeta(['authorSnippet', 'press'], {}),
    mainPage = _useMeta.mainPage,
    page = _useMeta.page,
    pressUrl = _useMeta.url;
  return jsx(Container$2, {
    children: jsxs("div", {
      sx: {
        variant: stylePath('container')
      },
      children: [jsxs(Type.H3, {
        sx: {
          variant: stylePath('title')
        },
        children: ["About ", author]
      }), jsx(RichText$1, {
        content: snippet
      }), jsxs(Type.Body1, {
        children: ["View ", jsxs(Link, {
          href: url,
          children: [author, "'s full biography here"]
        }), " or visit the ", mainPage, ' ', jsx(Link, {
          href: pressUrl,
          children: page
        }), " for our latest news."]
      })]
    })
  });
};

/* copied from here: https://www.npmjs.com/package/facepaint */

var facepaint = function facepaint(breakpoints) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    literal = _ref.literal,
    overlap = _ref.overlap;
  var mq = literal ? breakpoints : ['&'].concat(breakpoints);
  function flatten(obj) {
    if (_typeof(obj) !== 'object' || obj == null) {
      return [];
    }
    if (Array.isArray(obj)) {
      return obj.map(flatten);
    }
    var slots = {};
    var objects = {};
    var props = {};
    Object.keys(obj).forEach(function (key) {
      // Check if value is an array, but skip if it looks like a selector.
      // key.indexOf('&') === 0

      var item = obj[key];
      if (!Array.isArray(item) && literal) item = [item];
      if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
        var prior;
        item.forEach(function (v, index) {
          // Optimize by removing duplicated media query entries
          // when they are explicitly known to overlap.
          if (overlap && prior === v) {
            return;
          }
          if (v == null) {
            // Do not create entries for undefined values as this will
            // generate empty media media quries
            return;
          }
          prior = v;
          if (index === 0 && !literal) {
            props[key] = v;
          } else if (slots[mq[index]] === undefined) {
            slots[mq[index]] = _defineProperty({}, key, v);
          } else {
            slots[mq[index]][key] = v;
          }
        });
      } else if (_typeof(item) === 'object') {
        objects[key] = flatten(item);
      } else {
        props[key] = item;
      }
    });

    // Ensure that all slots and then child objects are pushed to the end
    mq.forEach(function (el) {
      if (slots[el]) {
        props[el] = slots[el];
      }
    });
    Object.assign(props, objects);
    return props;
  }
  return function () {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    return values.map(flatten);
  };
};

var mq = facepaint([640, 1152].map(function (bp) {
  return "@media (min-width: ".concat(bp, "px)");
}));
var defaultGutterWidths = [16];
var defaultContainerWidths = ['100%', 640, 1152];
var getWidthPercentageFromSizes = function getWidthPercentageFromSizes(sizes) {
  return sizes.map(function (size) {
    return "".concat(100 * size, "%");
  });
};

// Not currently used
// const getMsFlexPreferredSizes = (sizes: number[], paddings: string[]) =>
//   sizes.map((size, ind) => {
//     const padding = paddings[Math.min(ind, paddings.length - 1)]

//     return `calc(${100 * size}% - ${padding} * 2)`
//   })

var container = function container() {
  var outerMargin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['0 auto'];
  var containerWidths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultContainerWidths;
  var gutterWidths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGutterWidths;
  var paddings = gutterWidths.map(function (gw) {
    return "".concat(gw, "px");
  });
  return mq({
    boxSizing: 'border-box',
    position: 'relative',
    margin: outerMargin,
    maxWidth: containerWidths,
    width: ['auto'].concat(_toConsumableArray(containerWidths.slice(1))),
    paddingLeft: paddings,
    paddingRight: paddings
  });
};
var row = function row() {
  var centerX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var topSpacing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var bottomSpacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var gutterWidths = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultGutterWidths;
  var margins = gutterWidths.map(function (gw) {
    return "-".concat(gw / 2, "px");
  });
  return mq({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    marginLeft: margins,
    marginRight: margins,
    marginTop: topSpacing,
    marginBottom: bottomSpacing,
    justifyContent: centerX ? 'center' : 'flex-start',
    flexWrap: 'wrap'
  });
};
var column = function column() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hasPaddingTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hasPaddingBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var gutterWidths = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultGutterWidths;
  var paddings = gutterWidths.map(function (gw) {
    return "".concat(gw / 2, "px");
  });
  return mq({
    boxSizing: 'border-box',
    display: display,
    paddingLeft: paddings,
    paddingRight: paddings,
    paddingTop: hasPaddingTop ? paddings : [],
    paddingBottom: hasPaddingBottom ? paddings : [],
    width: getWidthPercentageFromSizes(sizes)
  });
};

var _excluded$2 = ["children", "outerMargin", "containerWidths", "gutterWidths"],
  _excluded2$2 = ["children", "hasPaddingTop", "hasPaddingBottom", "gutterWidths"],
  _excluded3 = ["children", "centerX", "topSpacing", "bottomSpacing", "gutterWidths"];
var breakpoints = {
  s: 0,
  m: 640,
  l: 1152
};
var Container = function Container(_ref) {
  var children = _ref.children,
    outerMargin = _ref.outerMargin,
    containerWidths = _ref.containerWidths,
    gutterWidths = _ref.gutterWidths,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx("div", _objectSpread(_objectSpread({
    css: container(outerMargin, containerWidths, gutterWidths)
  }, props), {}, {
    children: children
  }));
};
var parseSizeFromProps = function parseSizeFromProps(fn) {
  return Object.entries(breakpoints).map(fn);
};
var parseDisplay = function parseDisplay(props) {
  return parseSizeFromProps(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
      key = _ref3[0];
    return props["hide-".concat(key)] ? 'none' : 'block';
  });
};
var parseSizes = function parseSizes(props) {
  return parseSizeFromProps(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
      key = _ref5[0];
    return parseFloat(props[key]) || 1;
  });
};
var Column = function Column(_ref6) {
  var children = _ref6.children,
    hasPaddingTop = _ref6.hasPaddingTop,
    hasPaddingBottom = _ref6.hasPaddingBottom,
    gutterWidths = _ref6.gutterWidths,
    props = _objectWithoutProperties(_ref6, _excluded2$2);
  var sizes = parseSizes(props);
  var display = parseDisplay(props);
  return jsx("div", _objectSpread(_objectSpread({
    css: column(sizes, display, hasPaddingTop, hasPaddingBottom, gutterWidths)
  }, props), {}, {
    children: children
  }));
};
var Row = function Row(_ref7) {
  var children = _ref7.children,
    centerX = _ref7.centerX,
    topSpacing = _ref7.topSpacing,
    bottomSpacing = _ref7.bottomSpacing,
    gutterWidths = _ref7.gutterWidths,
    props = _objectWithoutProperties(_ref7, _excluded3);
  return jsx("div", _objectSpread(_objectSpread({
    css: row(centerX, topSpacing, bottomSpacing, gutterWidths)
  }, props), {}, {
    children: children
  }));
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Container: Container,
  Column: Column,
  Row: Row
});

var constructModIds = function constructModIds() {
  var idParts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _idParts = _slicedToArray(idParts, 3),
    module = _idParts[0],
    variant = _idParts[1],
    layout = _idParts[2];
  return [module, variant || layout ? [module, variant || layout].join(MODULE_VARIANT_SEPARATOR) : undefined].filter(Boolean);
};
var constructSiblingSpacingLookupMap = function constructSiblingSpacingLookupMap() {
  var A = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var B = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return B.filter(Boolean).reverse().reduce(function (acc, b) {
    A.filter(Boolean).reverse().map(function (a) {
      acc.push("".concat(a).concat(MODULE_ID_SEPARATOR).concat(b));
      return a;
    });
    return acc;
  }, []);
};
var getVariant = function getVariant(entity) {
  var _variantId;
  return (_variantId = variantId(entity)) !== null && _variantId !== void 0 ? _variantId : entity === null || entity === void 0 ? void 0 : entity.variants;
};
var extractModIdParts = function extractModIdParts(entity) {
  return [contentTypeId(entity), getVariant(entity) ? toSnakeCase(getVariant(entity)) : undefined, typeof layoutId(entity) === 'string' ? toSnakeCase(layoutId(entity)) : undefined];
};

var _excluded$1 = ["content", "style", "optionOverrides", "childOfPage"],
  _excluded2$1 = ["originalIndex"];
var ReactElementOrModule = function ReactElementOrModule(_ref) {
  var item = _ref.item,
    index = _ref.index,
    _ref$moduleIndexPrefi = _ref.moduleIndexPrefix,
    moduleIndexPrefix = _ref$moduleIndexPrefi === void 0 ? '' : _ref$moduleIndexPrefi,
    childOfPage = _ref.childOfPage;
  return /*#__PURE__*/React__default.isValidElement(item) ? jsx(item.type, _objectSpread({}, item.props)) : jsx(EVEntry, _objectSpread(_objectSpread({}, item), {}, {
    moduleIndex: "".concat(moduleIndexPrefix, "-").concat(leftPad(index)),
    track: childOfPage,
    moduleSpacing: true
  }));
};
var PaletteWrapper$1 = function PaletteWrapper(_ref2) {
  var palette = _ref2.palette,
    children = _ref2.children;
  return jsx(PaletteProvider, {
    value: usePalette$1(palette),
    children: children
  });
};
var isCriticalImage$1 = function isCriticalImage(_ref3) {
  var selectEntityObj = _ref3.selectEntityObj,
    withinBounds = _ref3.withinBounds,
    content = _ref3.content,
    includes = _ref3.includes;
  var entity = getEntity(selectEntityObj(content), includes);
  return !entity.critical && withinBounds && (contentTypeId(entity) === 'imageModule' || contentTypeId(entity) === 'imageCalloutModule') ? true : entity.critical;
};
var modOrContentId = function modOrContentId(entity, includes) {
  var _entity$data;
  return entity.nodeType === 'embedded-entry-block' ? contentTypeId(getEntity(entity === null || entity === void 0 ? void 0 : (_entity$data = entity.data) === null || _entity$data === void 0 ? void 0 : _entity$data.target, includes)) : entity.nodeType;
};
var modPartsOrContentId = function modPartsOrContentId(entity, includes) {
  var _entity$data2;
  return entity.nodeType === 'embedded-entry-block' ? extractModIdParts(getEntity(entity === null || entity === void 0 ? void 0 : (_entity$data2 = entity.data) === null || _entity$data2 === void 0 ? void 0 : _entity$data2.target, includes)) : entity.nodeType;
};
var RichText = function RichText(_ref4) {
  var _entity$sys;
  var document = _ref4.content,
    _ref4$style = _ref4.style,
    style = _ref4$style === void 0 ? {} : _ref4$style,
    optionOverrides = _ref4.optionOverrides,
    childOfPage = _ref4.childOfPage,
    entity = _objectWithoutProperties(_ref4, _excluded$1);
  var includes = useIncludes();
  var options = useOptions();
  var config = {
    optionOverrides: optionOverrides
  };
  var optionsWithOverrides = options(config);
  var siblingSpacing = useMeta(['siblingSpacing'], []);
  var siblingSpacingMap = toSiblingMap(siblingSpacing);
  var imageCriticalBound = useMeta(['imageCriticalBound']);
  var debugHydration = useDebugHydration();
  var doHydrateComponent = useDoHydrateComponent((_entity$sys = entity.sys) === null || _entity$sys === void 0 ? void 0 : _entity$sys.id);
  var doHydrate = !entity.sys || doHydrateComponent;
  if (!document) return jsx(Fragment$1, {});
  // For storybook
  if (typeof document === 'string') return jsx("div", {
    children: document
  });
  var untrimmedContentArr = Array.isArray(document) ? document : Array.isArray(document.content) ? document.content : [];
  var contentArr = untrimmedContentArr.reduce(function (acc, entry) {
    var nodeType = entry.nodeType,
      _entry$content = entry.content,
      content = _entry$content === void 0 ? [] : _entry$content;

    // When trimming rich content, we should only trim items that are
    // not assets or entries
    if (nodeType === 'embedded-entry-block' || nodeType === 'embedded-asset-block') {
      return acc.concat(entry);
    }
    var trimmedContent = content.filter(function (_ref5) {
      var value = _ref5.value;
      return !/^$/.test(value);
    });
    return trimmedContent.length ? acc.concat(_objectSpread(_objectSpread({}, entry), {}, {
      content: trimmedContent
    })) : acc;
  }, []).map(function (mod, i) {
    return _objectSpread(_objectSpread({}, mod), {}, {
      originalIndex: i
    });
  });
  var extractedDevModules = contentArr.filter(function (mod) {
    return __example__devModuleIds.indexOf(modOrContentId(mod, includes)) > -1;
  });

  // Walk over the modules and apply and sibling spacing that is needed
  var _applyToPairWhen = applyToPairWhen(contentArr.filter(function (mod) {
      return __example__devModuleIds.indexOf(modOrContentId(mod, includes)) === -1;
    }).map(function (mod, i) {
      return _objectSpread(_objectSpread({}, mod), {}, {
        index: i
      });
    }), function (prevMod, currMod, i) {
      var a = i !== 0 ? modPartsOrContentId(prevMod, includes) : undefined;
      var b = modPartsOrContentId(currMod, includes);
      var A = i !== 0 ? constructModIds(a) : [FIRST_MODULE_ID];
      var B = constructModIds(b);
      var lookupMap = constructSiblingSpacingLookupMap(A, B);
      return siblingSpacingMap[lookupMap.find(function (i) {
        return siblingSpacingMap[i];
      })];
    }, function (index, mod, spacingConfig) {
      return merge(mod, {
        spacing: spacingConfig.spacing[index] || {}
      });
    }),
    _applyToPairWhen2 = _slicedToArray(_applyToPairWhen, 1),
    spacedSansDevModules = _applyToPairWhen2[0];
  var moduleListLength = spacedSansDevModules.length;

  // Need to re-inject the dev modules back into the list of spaced modules
  // We loop over each extracted dev module and splice it back into the space modules
  var spacedModules = extractedDevModules.reduce(function (acc, _ref6) {
    var originalIndex = _ref6.originalIndex,
      mod = _objectWithoutProperties(_ref6, _excluded2$1);
    var pre = acc.slice(0, originalIndex);
    var post = acc.slice(originalIndex);
    return [].concat(_toConsumableArray(pre), [mod], _toConsumableArray(post));
  }, spacedSansDevModules);
  var paletteGroups = sequentialGroupBy(spacedModules, function (mod) {
    return contentTypeId(getEntity(mod.data.target, includes)) === 'palette';
  }, function (mod) {
    return mod.data.target;
  });
  var groupedBlocks = paletteGroups.map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      palette = _ref8[0],
      content = _ref8[1];
    return [palette, unnest(content, function (_ref9) {
      var nodeType = _ref9.nodeType;
      return nodeType === 'embedded-entry-block';
    })];
  });
  return jsxs(ConditionalWrapper, {
    condition: !doHydrate,
    wrapper: ConditionalHydrate,
    otherwise: debugHydration ? RedWrapper : undefined,
    children: [displayModMarker() && jsx(ModMarker, {
      entity: entity
    }), groupedBlocks.filter(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2);
        _ref11[0];
        var g = _ref11[1];
      return g.length;
    }).map(function (_ref12, i) {
      var _ref13 = _slicedToArray(_ref12, 2),
        palette = _ref13[0],
        groups = _ref13[1];
      return groups.map(function (group, j) {
        var content = documentToReactComponents({
          content: [].concat(group)
        }, optionsWithOverrides);
        var isEmbeddedEntry = group.nodeType === 'embedded-entry-block';
        var spacing = group.spacing || {};

        // in order to be able to apply styling between the last and first elements of a smart container, we merge the spacing styling below

        if (Array.isArray(group)) {
          spacing = _objectSpread(_objectSpread({}, group[0].spacing), group[group.length - 1].spacing);
        }
        var first = i === 0 && j === 0;
        var key = "rich-pallete_".concat(leftPad(i), "-group_").concat(leftPad(j));
        var parentId = contentTypeId(entity);
        if (isEmbeddedEntry) {
          var isCritical = isCriticalImage$1({
            selectEntityObj: function selectEntityObj(x) {
              var _x$data;
              return x === null || x === void 0 ? void 0 : (_x$data = x.data) === null || _x$data === void 0 ? void 0 : _x$data.target;
            },
            withinBounds: childOfPage && imageCriticalBound && Number(imageCriticalBound) ? i === 0 && j <= imageCriticalBound : undefined,
            content: group,
            includes: includes
          });
          return jsx(ConditionalWrapper, {
            condition: !!palette,
            wrapper: PaletteWrapper$1,
            palette: palette,
            children: jsx(EVEntry, _objectSpread(_objectSpread({}, content[0]), {}, {
              spacing: spacing,
              parentContentType: parentId,
              moduleIndex: key,
              track: childOfPage,
              critical: isCritical,
              removeTopSpacing: first,
              removeBottomSpacing: group.index + 1 === moduleListLength,
              moduleSpacing: true
            }))
          }, key);
        }
        return jsxs(ConditionalWrapper, {
          condition: !!palette,
          wrapper: PaletteWrapper$1,
          palette: palette,
          children: [displayModMarker() && jsx(ModMarker, {
            entity: entity
          }), jsx(SmartContainer, {
            parentContentType: parentId,
            spacing: spacing,
            styling: entity.styling,
            textContent: true,
            sx: _objectSpread({}, style),
            children: content.map(function (item, index) {
              return jsx(ReactElementOrModule, {
                index: index,
                item: item,
                moduleIndexPrefix: "key",
                childOfPage: childOfPage
              }, index);
            }, this)
          })]
        }, key);
      });
    })]
  });
};
var RichPage = function RichPage(props) {
  return RichText(_objectSpread(_objectSpread({}, props), {}, {
    childOfPage: true
  }));
};

var _excluded = ["modules"],
  _excluded2 = ["originalIndex"];
var PaletteWrapper = function PaletteWrapper(_ref) {
  var palette = _ref.palette,
    children = _ref.children;
  return jsx(PaletteProvider, {
    value: usePalette$1(palette),
    children: children
  });
};
var isCriticalImage = function isCriticalImage(_ref2) {
  var selectEntityObj = _ref2.selectEntityObj,
    withinBounds = _ref2.withinBounds,
    content = _ref2.content,
    includes = _ref2.includes;
  var entity = getEntity(selectEntityObj(content), includes);
  return !entity.critical && withinBounds && (contentTypeId(entity) === 'imageModule' || contentTypeId(entity) === 'imageCalloutModule') ? true : entity.critical;
};
var Modular = function Modular(_ref3) {
  var _ref3$modules = _ref3.modules,
    modules = _ref3$modules === void 0 ? [] : _ref3$modules,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var includes = useIncludes();
  var siblingSpacing = useMeta(['siblingSpacing'], []);
  var imageCriticalBound = useMeta(['imageCriticalBound']);
  var siblingSpacingMap = toSiblingMap(siblingSpacing);
  var restoreTopAndBottomSpacing = useMeta(['restoreTopAndBottomSpacing'], false);
  modules = modules.map(function (mod, i) {
    return _objectSpread(_objectSpread({}, mod), {}, {
      originalIndex: i
    });
  });
  var extractedDevModules = modules.filter(function (mod) {
    return __example__devModuleIds.indexOf(contentTypeId(getEntity(mod, includes))) > -1;
  });
  var _applyToPairWhen = applyToPairWhen(modules.filter(function (mod) {
      return __example__devModuleIds.indexOf(contentTypeId(getEntity(mod, includes))) === -1;
    }), function (prevMod, currMod, i) {
      var a = i !== 0 ? extractModIdParts(getEntity(prevMod, includes)) : undefined;
      var b = extractModIdParts(getEntity(currMod, includes));
      var A = i !== 0 ? constructModIds(a) : [FIRST_MODULE_ID];
      var B = constructModIds(b);
      var lookupMap = constructSiblingSpacingLookupMap(A, B);
      return siblingSpacingMap[lookupMap.find(function (i) {
        return siblingSpacingMap[i];
      })];
    }, function (index, mod, spacingConfig) {
      return merge(mod, {
        spacing: spacingConfig.spacing[index] || {}
      });
    }),
    _applyToPairWhen2 = _slicedToArray(_applyToPairWhen, 1),
    spacedSansDevModules = _applyToPairWhen2[0];
  var moduleListLength = spacedSansDevModules.length;

  // Need to re-inject the dev modules back into the list of spaced modules
  // We loop over each extracted dev module and splice it back into the space modules
  var spacedModules = extractedDevModules.reduce(function (acc, _ref4) {
    var originalIndex = _ref4.originalIndex,
      mod = _objectWithoutProperties(_ref4, _excluded2);
    var pre = acc.slice(0, originalIndex);
    var post = acc.slice(originalIndex);
    return [].concat(_toConsumableArray(pre), [mod], _toConsumableArray(post));
  }, spacedSansDevModules);
  var groupedModules = sequentialGroupBy(spacedModules, function (mod) {
    return contentTypeId(getEntity(mod, includes)) === 'palette';
  });
  return jsxs(Fragment$1, {
    children: [displayModMarker() && jsx(ModMarker, {
      entity: rest
    }), groupedModules.filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2);
        _ref6[0];
        var g = _ref6[1];
      return g.length;
    }).map(function (_ref7, key) {
      var _ref8 = _slicedToArray(_ref7, 2),
        palette = _ref8[0],
        modules = _ref8[1];
      /** Use palette wrapper if a palette exists, otherwise just children */
      return jsx(ConditionalWrapper, {
        condition: !!palette,
        wrapper: PaletteWrapper,
        palette: palette,
        children: modules.map(function (entity, idx) {
          var index = entity === null || entity === void 0 ? void 0 : entity.originalIndex;
          var isCritical = isCriticalImage({
            selectEntityObj: function selectEntityObj(x) {
              return x;
            },
            withinBounds: imageCriticalBound && Number(imageCriticalBound) ? index <= imageCriticalBound : undefined,
            content: entity,
            includes: includes
          });
          return createElement(EVEntry, _objectSpread(_objectSpread({}, entity), {}, {
            key: index,
            parentContentType: contentTypeId(rest),
            track: true,
            moduleIndex: "modularpage-".concat(index),
            critical: isCritical,
            removeTopSpacing: !restoreTopAndBottomSpacing ? key === 0 && idx === 0 : false,
            removeBottomSpacing: !restoreTopAndBottomSpacing ? index + 1 === moduleListLength : false,
            moduleSpacing: true
          }));
        })
      }, key);
    })]
  });
};

var EVPage = function EVPage(props) {
  var entity = useEntity(props);
  if (entity.err) {
    console.log({
      err: entity.err,
      props: props
    });
  }
  return sw$1({
    modularPage: Modular,
    richPage: RichPage
  })(contentTypeId(entity), _objectSpread(_objectSpread({}, props), entity));
};

var NA_FLAG_ID = 'not-applicable'; // Default not applicable flag ID

/**
 * @typedef {Object} Experience
 * @param {string} Experience.value The name of the cohort the user is in
 */

/**
 * @typedef {Object} Props
 * @param {string} experienceFlag The flag to switch the experience on
 * @param {any[]} experiencesList Ordered list of experiences IDs
 * @param {any[]} entityList The list of contentful entities to render
 * @param {Object.<string, Experience>} experiences List of experiences that the user is in
 * @param {Object.<string, string>} [entityMap] The list of contentful entities to render
 */

/**
 * Select
 * @param {Props} props - Same props as called by the `BaseExperienceEntitySelector'
 * @returns {Object}
 */
var selectEntity = function selectEntity() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    experienceFlag = _ref.experienceFlag,
    _ref$experiences = _ref.experiences,
    experiences = _ref$experiences === void 0 ? {} : _ref$experiences,
    _ref$entityMap = _ref.entityMap,
    entityMap = _ref$entityMap === void 0 ? {} : _ref$entityMap,
    _ref$experienceList = _ref.experienceList,
    experienceList = _ref$experienceList === void 0 ? [] : _ref$experienceList,
    _ref$entityList = _ref.entityList,
    entityList = _ref$entityList === void 0 ? [] : _ref$entityList,
    _ref$fullPageTest = _ref.fullPageTest,
    fullPageTest = _ref$fullPageTest === void 0 ? false : _ref$fullPageTest;
  var experience = experiences[experienceFlag];

  // This condition is for the URL contentType with multiple variants
  // e.g. full pages tests
  if (fullPageTest) {
    return entityList[(experience === null || experience === void 0 ? void 0 : experience.cohort) || 0];
  }
  var experienceValue = experience === null || experience === void 0 ? void 0 : experience.value;
  // Experience mapping based on mapping experienceFlag values to contentful
  // entity ids
  if (isObject(entityMap) && !isEmpty(entityMap)) {
    var entityId = entityMap[experienceValue] || entityMap[NA_FLAG_ID];
    return entityId ? {
      id: entityId
    } : null;
  }

  // Legacy experience mapping based on indexes
  var entityIndex = experienceList.findIndex(function (experience) {
    return experience === experienceValue;
  });
  return entityList[entityIndex] || entityList[0] || null;
};

/**
 * ExperienceEntitySelector
 *
 * Selects a contentful entity to render based on the experiences from chansey. The Fallback component
 * is used so that we can use custom rendering logic (selectEntity) rather than allowing Experiment
 * to decide what to render.
 *
 * @returns {*} The component to render
 */
var ExperienceEntitySelector = function ExperienceEntitySelector(props) {
  var experiences = useExperiences();
  var selectedEntity = selectEntity(_objectSpread(_objectSpread({}, props), {}, {
    experiences: experiences
  }));
  return jsx(Experiment, {
    id: props.experienceFlag,
    children: selectedEntity ? jsx(Fallback, {
      children: jsx(EVEntry, _objectSpread({}, selectedEntity))
    }) : null
  });
};
var ExperiencePageSelector = function ExperiencePageSelector(props) {
  var experiences = useExperiences();
  var selectedEntity = selectEntity(_objectSpread(_objectSpread({}, props), {}, {
    experiences: experiences
  }));
  return jsx(Experiment, {
    id: props.experienceFlag,
    children: selectedEntity ? jsx(Fallback, {
      children: jsx(EVPage, _objectSpread({}, selectedEntity))
    }) : null
  });
};

var Url = function Url(_ref) {
  var _author$sys;
  var link = _ref.link,
    variantFlag = _ref.variantFlag,
    _ref$variants = _ref.variants,
    variants = _ref$variants === void 0 ? [] : _ref$variants,
    _ref$authors = _ref.authors,
    authors = _ref$authors === void 0 ? [] : _ref$authors,
    _ref$editors = _ref.editors,
    editors = _ref$editors === void 0 ? [] : _ref$editors;
  var entity = link || variants[0];
  var author = useEntity(authors[0] || editors[0]);
  var _useMeta = useMeta(['authorSnippet'], {
      useSnippet: false
    }),
    useSnippet = _useMeta.useSnippet;
  return jsxs(Fragment$1, {
    children: [variants.length > 1 ? jsx(ExperiencePageSelector, {
      experienceFlag: variantFlag,
      entityList: variants,
      fullPageTest: true
    }) : jsx(EVPage, _objectSpread({}, entity)), useSnippet && author !== null && author !== void 0 && (_author$sys = author.sys) !== null && _author$sys !== void 0 && _author$sys.id ? jsx(AuthorSnippet, _objectSpread({}, author)) : null]
  });
};
var RootEVEntry = function RootEVEntry(props) {
  var entity = useEntity(props);
  var thing = _objectSpread(_objectSpread({}, props), entity);
  return jsx(Themed.root, {
    children: jsx(Url, _objectSpread({}, thing))
  });
};

var _templateObject;
var Global = function Global() {
  return jsx(Global$1, {
    styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", "\n\n      .uconsent-container {\n        width: 100%;\n        padding-bottom: 16px;\n        margin: 0 24px;\n        overflow: hidden;\n        transition: padding-bottom 0.5s, max-height 0.5s;\n      }\n\n      .email .uconsent-container {\n        padding-bottom: 16px;\n        max-height: 94px;\n        @media (max-width: 320px) {\n          max-height: 114px;\n        }\n      }\n    "])), emotionNormalize)
  });
};

export { AuthorSnippet, Col, Container$2 as Container, EVEntry, EVPage, ExperienceEntitySelector, Global as GlobalStyles, GridFromJson, index as GridLayout, Link, LinkWithChevron, Palette, PaletteProvider, RichText$1 as RichText, RootEVEntry, Row$1 as Row, SmartContainer, columnSizeContext, isChildOfContainerContext, useContainerSize, usePalette };
